
import React, { useEffect, useState } from 'react';

// Use public paths for images:
const images = [
  'nametag/1.png',
  'nametag/2.png',
  'nametag/3.png',
  'nametag/5.png',
  'nametag/4.png',
  'nametag/6.png',
];

const BannerWithRotatingNametags = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIdx((prev) => (prev + 1) % images.length);
    }, 2500); // 2.5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ width: '100%', textAlign: 'center', padding: '40px 0', }}>
      <img
        src={images[idx]}
        alt="Name Tag"
        style={{
          width: '400px',
          borderRadius: '24px',
          filter: 'drop-shadow(0 10px 10px rgba(0,0,0,0.7))',
          objectFit: 'cover'
        }}
      />
    </div>
  );
};

export default BannerWithRotatingNametags;
